'use client'

import { useState } from 'react'
import { readClientConsent } from '@/lib/tracking/consent'

/**
 * One consent decision gates ALL tracking stacks (C-C3): the script components
 * rendered inside this gate — Google tags, Clarity, FirstPromoter, Meta pixel —
 * mount only when `ps_privacy` resolves to granted. Denied (opt-out, GPC,
 * gated geo pre-seeded by the proxy) mounts NOTHING: full suppression, not
 * consent-mode degradation. Consent changes apply via the privacy panel's page
 * reload, so a mount-time read is authoritative for the page's lifetime.
 */
export function ConsentGate({ children }: { children: React.ReactNode }) {
  const [allowed] = useState<boolean>(() => readClientConsent() === 'granted')
  if (!allowed) return null
  return <>{children}</>
}
